/**
 * WireRegion — a geographic region used for ABAC gating, article tagging, and feed configuration.
 * The slug is the stable identifier flowing through LDAP/IdAM, JACOs, and article tags.
 * The label is display-only.
 *
 * Data lives in /public/config/regions.json so it can be swapped at deploy time
 * without a frontend rebuild. Use `fetchRegions()` or `useRegions()` to load it.
 *
 * ⚠️  The JSON file contains DEV PLACEHOLDER values. Real slugs are replaced
 *     on the production network without modifying this code.
 */
export type WireRegion = {
  slug: string
  label: string
}

export async function fetchRegions(): Promise<WireRegion[]> {
  const res = await fetch('/config/regions.json')
  if (!res.ok) throw new Error(`Failed to load regions config: ${res.status}`)
  return res.json() as Promise<WireRegion[]>
}
